import React from 'react';
import PropTypes from 'prop-types';

function Stepper({ steps, activeStep })
{
    return (
        <div className="tw-flex tw-flex-row tw-p-5">
            {steps.map((step, index) => (
                <div key={step.id} className="tw-flex-1">
                    <div className="tw-flex tw-flex-col tw-items-center">
                        <div className={`tw-w-12 tw-h-12 ${index === activeStep ? 'tw-bg-primary-default' : 'tw-bg-gray-500'} tw-text-center tw-rounded-full tw-flex tw-items-center tw-justify-center`}>
                            <span className="tw-text-white tw-font-medium">{index + 1}</span>
                        </div>

                        <div className="tw-mt-2">
                            <h4 className="tw-text-sm tw-font-semibold">{step.title}</h4>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

Stepper.propTypes = {
    steps: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            title: PropTypes.string.isRequired,
        }),
    ).isRequired,
    activeStep: PropTypes.number,
};

export default Stepper;
